import { z } from 'zod';
import { defineEndpoint } from '../define';
import { RoleSchema } from './list';

export const CreateRoleBodySchema = z.object({
  name: z.string().trim().min(1).max(100),
  permissions: z
    .array(z.string())
    .default([])
    .transform((keys) => [...new Set(keys)]),
});

export type CreateRoleBody = z.input<typeof CreateRoleBodySchema>;

export const CreateRoleResponseSchema = z.object({
  data: RoleSchema,
});

export const createRole = defineEndpoint({
  method: 'POST',
  path: '/v1/roles',
  params: z.object({}),
  query: z.object({}),
  body: CreateRoleBodySchema,
  response: CreateRoleResponseSchema,
  successStatus: 201,
});
